import React from 'react'
import { ActionElement } from '../NextActions/ActionElement'
import { SelectorActions, SubActionHeader } from '../Surveys.styled'
import { CustomAction } from '../types'

type UserActionsProps = {
  onAnyAction: any // TODO: Type this properly
  userActions: CustomAction[]
}

export const UserActions = ({ onAnyAction, userActions }: UserActionsProps) => (
  <SelectorActions>
    {userActions.map((action) =>
      action.isHidden ? null : (
        <React.Fragment key={action.label}>
          {action.header && <SubActionHeader>{action.header}</SubActionHeader>}
          <ActionElement action={action} onAction={onAnyAction} />
        </React.Fragment>
      )
    )}
  </SelectorActions>
)
